<script setup lang="ts">
defineProps<{
  transitionName: string;
  loading?: boolean;
}>();

defineOptions({
  inheritAttrs: false,
});
</script>

<template>
  <section>
    <ul v-bind="$attrs">
      <TransitionGroup :name="transitionName">
        <slot></slot>
      </TransitionGroup>
    </ul>
    <BaseLoader v-if="loading" />
  </section>
</template>
